import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { CrownRipsWidgetDataType, WidgetEntry } from '../types';

// Backend-driven: the widget shows only once /crown-rips/game resolves (its gameId is set from that
// call, which the server 404s when `crown_rips_enabled` is off). So the server — not a bare client flag
// — decides whether it appears; a client with a stale flag but a disabled server never renders it.
export function useCrownRipsWidgets() {
  const { crownRipsStore } = useStores();
  const { gameId } = crownRipsStore;

  const crownRipsWidgets: CrownRipsWidgetDataType[] = useMemo(() => {
    if (gameId == null) {
      return [];
    }
    return [
      {
        key: 'crown-rips',
        dataTestId: 'crown-rips-widget',
      },
    ];
  }, [gameId]);

  return useMemo(
    () => crownRipsWidgets.map((data): WidgetEntry<'crownRips'> => ({ data, type: 'crownRips', id: data.key })),
    [crownRipsWidgets],
  );
}
